import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row px-4 py-2" }
const _hoisted_2 = { class: "col-12 offset-lg-1 col-lg-10 row g-0" }
const _hoisted_3 = {
  key: 0,
  class: "form-group col-12 col-lg-5 pe-lg-2 d-flex flex-column"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "line-of-service" }, [
  /*#__PURE__*/_createTextVNode(" Line of Service "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_5 = {
  key: 0,
  class: "d-flex flex-wrap mt-1"
}
const _hoisted_6 = { class: "form-check custom-radio form-check-inline d-inline" }
const _hoisted_7 = ["id", "checked", "value"]
const _hoisted_8 = ["for"]
const _hoisted_9 = { class: "me-1" }
const _hoisted_10 = {
  key: 1,
  class: "col-12 col-lg-6 pe-lg-3"
}
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "referral-reason" }, [
  /*#__PURE__*/_createTextVNode(" Referral Reason "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_13 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_14 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "referral-date" }, [
  /*#__PURE__*/_createTextVNode(" Referral Date "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_17 = { class: "input-group date datepickerInput" }
const _hoisted_18 = ["value"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_20 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "referral-service-location" }, " Patient Current Location ", -1 /* HOISTED */)
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "inquiry-date" }, " Inquiry Date ", -1 /* HOISTED */)
const _hoisted_25 = { class: "input-group date datepickerInput" }
const _hoisted_26 = ["value"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_NewReferralInformation = _resolveComponent("NewReferralInformation")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Referral Information",
    "full-height": false,
    "application-id": _ctx.referral.application
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.referral.application == _ctx.hospiceApplicationId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                (_ctx.lineOfServices.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lineOfServiceOptions, (lineOfService) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("input", {
                            type: "radio",
                            id: `line- of-service-${lineOfService.name}`,
                            class: "form-check-input",
                            name: "line-of-service",
                            checked: _ctx.referral.lineOfService === lineOfService.value,
                            value: `${lineOfService.value}`,
                            disabled: ""
                          }, null, 8 /* PROPS */, _hoisted_7),
                          _createElementVNode("label", {
                            class: "form-check-label",
                            for: `line-of-service-${lineOfService.name}`
                          }, [
                            _createElementVNode("span", _hoisted_9, _toDisplayString(lineOfService.name), 1 /* TEXT */)
                          ], 8 /* PROPS */, _hoisted_8)
                        ]))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _withDirectives(_createElementVNode("textarea", {
                    class: _normalizeClass(["form-control", `${!_ctx.v$.referral.referralReason.$error ? '' : 'field-invalid'}`]),
                    name: "referral-reason",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.referral.referralReason) = $event)),
                    placeholder: "Enter Reason",
                    maxlength: "500",
                    onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.referralReason.$touch && _ctx.v$.referral.referralReason.$touch(...args)))
                  }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                    [_vModelText, _ctx.referral.referralReason]
                  ])
                ]),
                (_ctx.v$.referral.referralReason.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Referral reason is required."))
                  : _createCommentVNode("v-if", true)
              ])),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_DatePicker, {
                options: _ctx.datePickerOptions,
                getDate: _ctx.handleDateChange
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("input", {
                      name: "referralDate",
                      type: "text",
                      class: _normalizeClass(["form-control", `${!_ctx.v$.referral.referralDate.$error ? '' : 'field-invalid'}`]),
                      placeholder: "MM/DD/YYYY",
                      value: _ctx.formatDateInput(_ctx.referral.referralDate),
                      onChange: _cache[2] || (_cache[2] = (e) => _ctx.handleDateChange(e.target.value, e.target.name)),
                      autocomplete: "off",
                      onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.referralDate.$touch && _ctx.v$.referral.referralDate.$touch(...args)))
                    }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_18),
                    _hoisted_19,
                    (_ctx.v$.referral.referralDate.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.v$.referral.referralDate.$errors[0].$message), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["options", "getDate"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                name: "referral-service-location",
                maxlength: "50",
                type: "text",
                placeholder: "Enter Current Location",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.referral.patientCurrentLocation) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.referral.patientCurrentLocation]
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createVNode(_component_DatePicker, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("input", {
                      id: "inquiry-date",
                      name: "inquiryDate",
                      type: "text",
                      class: "form-control",
                      placeholder: "MM/DD/YYYY",
                      value: _ctx.referral.inquiryDate ? _ctx.formatDateInput(_ctx.referral.inquiryDate) : 'Not Available',
                      autocomplete: "off",
                      disabled: ""
                    }, null, 8 /* PROPS */, _hoisted_26),
                    _hoisted_27
                  ])
                ]),
                _: 1 /* STABLE */
              })
            ])
          ]),
          _createVNode(_component_NewReferralInformation, { "provider-id": _ctx.providerId }, null, 8 /* PROPS */, ["provider-id"])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}